import TermsPage from "./containers/TermsPageContainer";
export default TermsPage;
